import React from 'react'
import PropTypes from 'prop-types'

const CLASSES = 'tw:ml-1 tw:inline-flex tw:items-center tw:justify-center tw:h-9'
  + ' tw:border-0 tw:bg-transparent tw:cursor-pointer tw:text-gray-500'

const RemoveButton = ({ onClick }) => (
  <button type="button" className={CLASSES} aria-label="Retirer" onClick={onClick}>
    <i className="fas fa-times" />
  </button>
)

RemoveButton.propTypes = {
  onClick: PropTypes.func.isRequired
}

export default RemoveButton
